import { gql } from '@apollo/client';

export const GET_CONSULTAS_ROL = gql`
    query GetConsultasRol($idRol: Int!) {
        consultaRolesByRol(idRol: $idRol) {
            idConsulta
            dataPrivacy
            idConsultaNavigation {
                nombre
                descripcion
            }
        }
    }
`;

export const adaptConsultasRol = (data) => {
    return data?.consultaRolesByRol?.map((consulta) => ({
        idConsulta: consulta.idConsulta,
        nombre: consulta.idConsultaNavigation.nombre,
        descripcion: consulta.idConsultaNavigation.descripcion,
        dataPrivacy: consulta.dataPrivacy
    })) || [];
}